import Vue from 'vue'
import Vuex from 'vuex'

import util from '@/config/util'

Vue.use(Vuex)

const SHOWLOADING =  'SHOWLOADING'; //loading
const HIDELOADING =  'HIDELOADING'; //loading

const SETUSERINFO = 'SETUSERINFO';

export default new Vuex.Store({
    state: {
        showLoading: false,
        userInfo: {

        }
    },
    getters: {
        getUserInfo(state) {
            return state.userInfo
        }
    },
    mutations: {
        [SHOWLOADING](state) {
            state.showLoading = true
        },
        [HIDELOADING](state) {
            state.showLoading = false
        },
        [SETUSERINFO](state, userInfo) {
            state.userInfo = userInfo
        }
    },
    actions: {
        showloader: ({commit}) => {
            commit(SHOWLOADING)
        },
        hideloader: ({commit}) => {
            commit(HIDELOADING)
        },
        setUser: ({commit}, userInfo) => {
            commit(SETUSERINFO, userInfo)
        }
    }
})






















